<template>
  <div class="chart_container">
    <h2 v-if="title">{{title}}</h2>
    <p class="about_chart" v-if="about_chart" v-html="about_chart"></p>
    <router-link :to="link_to">
      <img :src="svg_file" width="100%" />
    </router-link>
  </div>
</template>

<script>
export default {
  props: ["svg_file", "min_width", "link_to", "title", "about_chart"]
};
</script>

<style lang="css" scoped>
h2 {
  font-family: "Archivo Black", sans-serif;
  font-size: 1.2rem;
  margin: 0;
  color: black;
}
p.about_chart {
  margin: 0;
  font-size: 0.9rem;
  color: slategray;
  text-align: left;
  padding: 0;
  padding-left: 1rem;
}
.chart_container:hover {
  border: 3px solid black;
}
.chart_container {
  border: 6px solid white;
  /* background-color: white; */
  width: 100%;
}
.router-link {
  border: 6px solid red;
}
</style>